export const UserRole={
    Admin:"admin",
    Vendor:"vendor",
    Agent:"agent",
}